/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Document on Azure Functions
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Persona } from './Persona';
import {
    PersonaFromJSON,
    PersonaFromJSONTyped,
    PersonaToJSON,
} from './Persona';

/**
 * 
 * @export
 * @interface ProjectContext
 */
export interface ProjectContext {
    /**
     * 
     * @type {string}
     * @memberof ProjectContext
     */
    writingStyle?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectContext
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectContext
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectContext
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectContext
     */
    technologiesUsed?: string;
    /**
     * 
     * @type {Array<Persona>}
     * @memberof ProjectContext
     */
    eligiblePersonas?: Array<Persona>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectContext
     */
    definitionOfReady?: Array<string>;
}

/**
 * Check if a given object implements the ProjectContext interface.
 */
export function instanceOfProjectContext(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProjectContextFromJSON(json: any): ProjectContext {
    return ProjectContextFromJSONTyped(json, false);
}

export function ProjectContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectContext {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'writingStyle': !exists(json, 'writingStyle') ? undefined : json['writingStyle'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'technologiesUsed': !exists(json, 'technologiesUsed') ? undefined : json['technologiesUsed'],
        'eligiblePersonas': !exists(json, 'eligiblePersonas') ? undefined : ((json['eligiblePersonas'] as Array<any>).map(PersonaFromJSON)),
        'definitionOfReady': !exists(json, 'definitionOfReady') ? undefined : json['definitionOfReady'],
    };
}

export function ProjectContextToJSON(value?: ProjectContext | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'writingStyle': value.writingStyle,
        'language': value.language,
        'name': value.name,
        'description': value.description,
        'technologiesUsed': value.technologiesUsed,
        'eligiblePersonas': value.eligiblePersonas === undefined ? undefined : ((value.eligiblePersonas as Array<any>).map(PersonaToJSON)),
        'definitionOfReady': value.definitionOfReady,
    };
}

